/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useReducer } from "react";
import { useOutletContext, useLocation, useNavigate } from "react-router-dom";
import { useAdminCreateUser } from "@/services/userService";
import { isAxiosError } from "axios";
import { axiosErrorToStringError } from "@/utils/axiosErrorToStringError";
import { ArrowBigRight, Trash, Save } from "lucide-react";
import { useAdminGetRolesSWR, useAdminGetRolesDefinitionsSWR } from "@/services/roleService";
import { useAdminGetSkillsSWR } from "@/services/skillService";
import { useAdminGetCompetitionsSWR } from "@/services/competitionService";
import { useAdminGetRegionsSWR } from "@/services/regionService";

const initialState = {
    apiPayload: {
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        email_digest: '',
        password: '',
        enabled: true,
        role_ids: [],
        on_keycloak: true,
        on_inscriptions_plateform: false,
        send_welcome_email: true,
    },
    roles: [],
    role_filter: {
        type: '',
        skill_id: '',
        competition_id: '',
    },
    selected_role: "",
    select_region: "",
    error_message: "",
    isLoading: false
}



const ACTIONS = {
    SET_API_PAYLOAD_FIELD: 'setApiPayloadField',
    SET_ROLE_FILTER: 'setRoleFilter',
    SET_SELECTED_ROLE: 'setSelectedRole',
    SET_SELECTED_REGION: 'setSelectedRegion',
    ADD_ROLE: 'addRole',
    REMOVE_ROVE: 'removeRole',
    SET_ERROR_MESSAGE: 'setErrorMessage',
    SET_IS_LOADING: 'setIsLoading',
}



const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_API_PAYLOAD_FIELD:
            return { ...state, apiPayload: { ...state.apiPayload, [action.subtype]: action.payload }, error_message: null }
        case ACTIONS.SET_ROLE_FILTER:
            return { ...state, role_filter: { ...state.role_filter, [action.subtype]: action.payload } }
        case ACTIONS.SET_SELECTED_ROLE:
            return { ...state, selected_role: action.payload }
        case ACTIONS.SET_SELECTED_REGION:
            return { ...state, select_region: action.payload }
        case ACTIONS.ADD_ROLE:
            return { ...state, apiPayload: { ...state.apiPayload, role_ids: [...state.apiPayload.role_ids, { role_id: Number(state.selected_role), region_id: Number(state.select_region) || null} ] } }
        case ACTIONS.REMOVE_ROVE:
            return { ...state, apiPayload: { ...state.apiPayload, role_ids: state.apiPayload.role_ids.filter((role_ass) => role_ass.role_id != Number(action.payload)) } }
        case ACTIONS.SET_ERROR_MESSAGE:
            return { ...state, error_message: action.payload }
        case ACTIONS.SET_IS_LOADING:
            return { ...state, isLoading: action.payload }
        default:
            return state
    }
}



export default function Add() {

    const [ , setPageTitle,  , setShowBackButton] = useOutletContext()
    const [state, dispatch] = useReducer(reducer, initialState)

    const navigate = useNavigate()
    const location = useLocation()

    const {data: roles } = useAdminGetRolesSWR()
    const {data: rolesDefinitions } = useAdminGetRolesDefinitionsSWR()
    const {data: skills } = useAdminGetSkillsSWR()
    const {data: competitions } = useAdminGetCompetitionsSWR()
    const {data: regions } = useAdminGetRegionsSWR()

    const adminCreateUser = useAdminCreateUser()


    /* Création d'un username depuis le prénom et le nom */
    /*const createUsername = () => {
        const first_name = _.kebabCase(_.deburr(state.apiPayload.first_name))
        const last_name = _.kebabCase(_.deburr(state.apiPayload.last_name))
        const random = Math.floor(Math.random() * 1000)

        const username = `${first_name}.${last_name}.${random}`
        return username
    }*/


    /* Lorsque le prénom ou le nom changent, on met à jour le username */
    // useEffect(() => {
    //     if (state.apiPayload.first_name && state.apiPayload.last_name) {
    //         dispatch({ type: ACTIONS.SET_API_PAYLOAD_FIELD, subtype: "username", payload: createUsername() })
    //     }
    // }, [state.apiPayload.first_name, state.apiPayload.last_name])


    /* On met à jour le titre et le bouton de retour */
    useEffect(() => {
        setPageTitle('Ajouter un utilisateur')
        setShowBackButton(true)

        return () => {
            setPageTitle("Titre")
            setShowBackButton(false)
        }
    }, [])


    /* Gestion des changements de champs du formulaire a l'exception des rôles */
    const handleChange = (e) => {
        dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: null });
        dispatch({ type: ACTIONS.SET_API_PAYLOAD_FIELD, subtype: e.target.name, payload: e.target.type == 'checkbox' ? e.target.checked : e.target.value })
    }


    /* Soumission du formulaire */
    const handleSubmit = async (e) => {
        e.preventDefault()

        if(!state.apiPayload.first_name || !state.apiPayload.last_name || !state.apiPayload.password || !state.apiPayload.email ) {
            dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: "Veuillez remplir tous les champs obligatoires" });
            return 
        }

        const payload = {
            ...state.apiPayload
        }

        dispatch({ type: ACTIONS.SET_IS_LOADING, payload: true });

        try {
            await adminCreateUser(payload)
            navigate(location.state?.from ?? "/admin/users")
        } catch (error) {
            console.error('admin/users/add::handleSubmit::error', error)
            if (error?.response?.status === 412) {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: "Erreur de validation en base de données (username ou email déjà utilisé, contrainte non respectée)" });
            } else if (isAxiosError(error)) {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: axiosErrorToStringError(error) });
            } else {
                dispatch({ type: ACTIONS.SET_ERROR_MESSAGE, payload: error?.message || "Erreur inconnue" });
            }
        } finally {
            dispatch({ type: ACTIONS.SET_IS_LOADING, payload: false });
        }
    }





    return (
        <>
            <h2 className="text-secondary text-lg flex-none content-center mb-4">
                Paramètres de l&apos;utilisateur
            </h2>

            <form className="flex flex-col gap-4" onSubmit={(e) => handleSubmit(e)}>

                {/* Premiere ligne : username et password */}
                <div className="w-full flex flex-col flex-wrap gap-4">
                    <div className="md:w-[100%] flex flex-row flex-wrap gap-5 content-stretch pr-[10px]">
                        <div className="flex flex-col gap-2 flex-1">
                            <label className="text-primary text-base" htmlFor="first_name">
                                Nom d&apos;utilisateur <span className="text-secondary">(généré)</span>
                            </label>
                            <input type="text" className="w-full p-1 border border-secondary rounded-md bg-gray-100"
                                id="username" name="username" 
                                placeholder="Sera généré automatiquement ..."
                                disabled
                                readOnly />
                        </div>
                        <div className="flex flex-col gap-2 flex-1">
                            <label className="text-primary text-base" htmlFor="last_name">
                                Password <span className="text-red-500">*</span>
                            </label>
                            <input type="password" className="w-full p-1 border border-secondary rounded-md" 
                                required
                                id="password" name="password" 
                                value={state.apiPayload.password} 
                                onChange={handleChange} />
                        </div> 
                    </div>

                    {/* Deuxième ligne : prénom et nom */}
                    <div className="md:w-[100%] flex flex-row flex-wrap gap-5 content-stretch">
                        <div className="flex flex-col gap-2 flex-1">
                            <label className="text-primary text-base" htmlFor="first_name">
                                Prénom <span className="text-red-500">*</span>
                            </label>
                            <input type="text" className="w-full p-1 border border-secondary rounded-md"
                                required
                                id="first_name" name="first_name" 
                                value={state.apiPayload.first_name} 
                                onChange={handleChange} />
                        </div>
                        <div className="flex flex-col gap-2 flex-1">
                            <label className="text-primary text-base" htmlFor="last_name">
                                Nom <span className="text-red-500">*</span>
                            </label>
                            <input type="text" className="w-full p-1 border border-secondary rounded-md" 
                                required
                                id="last_name" name="last_name" 
                                value={state.apiPayload.last_name} 
                                onChange={handleChange} />
                        </div>    
                    </div>

                    {/* Troisieme ligne : email */}
                    <div className="md:w-[60%] flex flex-row flex-wrap gap-5 content-stretch">
                        <div className="flex flex-col gap-2 flex-auto">
                            <label className="text-primary text-base" htmlFor="email">
                                Email <span className="text-red-500">*</span>
                            </label>
                            <input type="text" className="w-full p-1 border border-secondary rounded-md"
                                required
                                id="email" name="email" 
                                value={state.apiPayload.email} 
                                onChange={handleChange} />
                        </div>  
                    </div>

                    {/* Troisieme ligne : email_digest */}
                    <div className="md:w-[60%] flex flex-row flex-wrap gap-5 content-stretch">
                        <div className="flex flex-col gap-2 flex-auto">
                            <label className="text-primary text-base" htmlFor="email">
                                Email pour les résumés
                            </label>
                            <input type="text" className="w-full p-1 border border-secondary rounded-md"
                                required
                                id="email_digest" name="email_digest" 
                                value={state.apiPayload.email_digest} 
                                onChange={handleChange} />
                        </div>  
                    </div>

                    {/* Quatrieme ligne : activé */}
                    <div className="flex flex-row gap-5">
                        <div className="flex flex-row gap-2 items-center">
                            
                            <input type="checkbox" className="h-6 w-6 border border-secondary rounded-md content-center"
                                required
                                id="enabled" name="enabled" 
                                checked={state.apiPayload.enabled} 
                                onChange={handleChange} />

                            <label className="text-primary text-base content-center" htmlFor="enabled">
                                Activé
                            </label>
                        </div>
                    </div>

                    {/* Ligne : attaché à keycloak */}
                    <div className="flex flex-row gap-5">
                        <div className="flex flex-row gap-2 items-center">
                            
                            <input type="checkbox" className="h-6 w-6 border border-secondary rounded-md content-center"
                                required
                                id="on_keycloak" name="on_keycloak" 
                                checked={state.apiPayload.on_keycloak} 
                                onChange={handleChange} />

                            <label className="text-primary text-base content-center" htmlFor="on_keycloak">
                                Attaché à Keycloak <span className="italic text-sm">(si activé, l&apos;utilisateur devra passer par Keycloak pour se connecter)</span>
                            </label>
                        </div>
                    </div>

                    {/* Ligne : attaché à la plateforme d'inscription */}
                    <div className="flex flex-row gap-5">
                        <div className="flex flex-row gap-2 items-center">
                            
                            <input type="checkbox" className="h-6 w-6 border border-secondary rounded-md content-center"
                                required
                                id="on_inscriptions_plateform" name="on_inscriptions_plateform" 
                                checked={state.apiPayload.on_inscriptions_plateform} 
                                onChange={handleChange} />

                            <label className="text-primary text-base content-center" htmlFor="on_inscriptions_plateform">
                                Attaché à la plateforme d&apos;inscription <span className="italic text-sm">(si activé, l&apos;utilisateur ne pourra plus modifier son email)</span>
                            </label>
                        </div>
                    </div>

                    {/* Ligne : Envoyer le mail de bienvenue */}
                    <div className="flex flex-row gap-5">
                        <div className="flex flex-row gap-2 items-center">
                            
                            <input type="checkbox" className="h-6 w-6 border border-secondary rounded-md content-center"
                                required
                                id="send_welcome_email" name="send_welcome_email" 
                                checked={state.apiPayload.send_welcome_email} 
                                onChange={handleChange} />

                            <label className="text-primary text-base content-center" htmlFor="send_welcome_email">
                                Envoyer le mail de bienvenue
                            </label>
                        </div>
                    </div>

                    {/* Derniere ligne : gestion des rôles */}
                    <div className="w-full flex flex-row gap-5 content-stretch">
                        <div className="flex flex-col flex-1 border border-secondary rounded-md px-2 py-1 bg-gray-100 gap-3">
                            <h3 className="text-secondary">Ajouter un role</h3>
                            <div className="w-full flex flex-row items-center text-sm">
                                <div className="flex flex-col flex-grow gap-2">
                                    <div className="text-primary flex flex-row flex-wrap items-center gap-1">
                                        <label>
                                            Type :
                                        </label>
                                        <select className="border-0 py-0 text-sm"
                                            onChange={(e) => dispatch({ type: ACTIONS.SET_ROLE_FILTER, subtype: "type", payload: e.target.value })} 
                                            value={state.role_filter.type}>

                                            <option value="">-</option>
                                            {rolesDefinitions && Object.keys(rolesDefinitions)?.map((role, i) => {
                                                return (
                                                    <option key={i} value={role}>
                                                        {role}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="text-primary flex flex-row flex-wrap items-center gap-1">
                                        <label>
                                            Métier :
                                        </label>
                                        <select className="border-0 py-0 text-sm"
                                            onChange={(e) => dispatch({ type: ACTIONS.SET_ROLE_FILTER, subtype: "skill_id", payload: e.target.value })} 
                                            value={state.role_filter.skill_id}>

                                            <option value="">-</option>
                                            {skills?.map((skill, i) => {
                                                return (
                                                    <option key={i} value={skill.id}>
                                                        {skill.code} - {skill.name}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="text-primary flex flex-row flex-wrap items-center gap-1">
                                        <label>
                                            Compétition :
                                        </label>
                                        <select className="border-0 py-0 text-sm"
                                            onChange={(e) => dispatch({ type: ACTIONS.SET_ROLE_FILTER, subtype: "competition_id", payload: e.target.value })} 
                                            value={state.role_filter.competition_id}>

                                            <option value="">-</option>
                                            {competitions?.map((competition, i) => {
                                                return (
                                                    <option key={i} value={competition.id}>
                                                        {competition.code} - {competition.name}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                    <div className="text-primary flex flex-row flex-wrap items-center gap-1">
                                        <label>
                                            Rôles possibles :
                                        </label>
                                        <select className="border-0 py-0 text-sm"
                                            onChange={(e) => dispatch({ type: ACTIONS.SET_SELECTED_ROLE, payload: e.target.value })} 
                                            value={state.selected_role}
                                        >
                                            <option value="">-</option>
                                            {roles?.filter((role) => { 
                                                let result = true
                                                if(state?.role_filter?.type && state?.role_filter?.type.length > 0) 
                                                    result &&= role.type === state.role_filter.type

                                                if (state?.role_filter?.skill_id && state?.role_filter?.skill_id.length > 0)
                                                    result &&= role.skill_id === Number(state.role_filter.skill_id)

                                                if (state?.role_filter?.competition_id && state?.role_filter?.competition_id.length > 0)
                                                    result &&= role.competition_id === Number(state.role_filter.competition_id)
                                                
                                                if( state?.apiPayload?.role_ids?.filter((role_ass) => role_ass.role_id == role.id).length > 0) result = false

                                                return result

                                            })?.map((role, i) => {
                                                return (
                                                    <option key={i} value={role.id}>
                                                        {role.name}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                        <select className="border-0 py-0 text-sm"
                                            onChange={(e) => dispatch({ type: ACTIONS.SET_SELECTED_REGION, payload: e.target.value })} 
                                            value={state.select_region}
                                        >
                                            <option value="">-</option>
                                            {regions?.map((region, i) => {
                                                return (
                                                    <option key={i} value={region.id}>
                                                        {region.code}
                                                    </option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="items-center">
                                    { state?.selected_role && <button
                                        onClick={(e) => {e.preventDefault();dispatch({ type: ACTIONS.ADD_ROLE, payload: state.selected_role })}}
                                    >
                                        <ArrowBigRight size={24} className="text-primary hover:text-blue-600" />
                                    </button> }
                                </div>
                            </div>

                        </div>
                        <div className="flex flex-1 flex-col border border-secondary rounded-md px-2 py-1 bg-gray-100 gap-3">
                            <h3 className="text-secondary">Roles selectionnés</h3>
                            <div className="w-full flex flex-row flex-wrap gap-2">
                                {roles &&state.apiPayload.role_ids.map((role_ass, i) => {
                                    
                                    const role = roles?.find((role) => role.id === role_ass.role_id)
                                    const borderColor = role.rights.filter((right) => right.includes("_admin")).length > 0
                                        ? "border-red-500"
                                        : "border-blue-500";

                                    return ( 
                                        <div key={i} className={`${borderColor} text-sm border rounded-md px-2 py-1 flex items-center gap-1`}>
                                            {role.name} 
                                            {role_ass.region_id && <span className="text-secondary"> ({regions.find((region) => region.id === role_ass.region_id)?.code})</span>}
                                            <button
                                            onClick={(e) => {e.preventDefault();dispatch({ type: ACTIONS.REMOVE_ROVE, payload: role_ass.role_id })}}
                                            >
                                                <Trash size={14} className="text-red-500 hover:text-red-700" />
                                            </button>
                                        </div> 
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                    {/* Fin : sauvegarder et message d'erreur */}
                    <div className="w-[50%] gap-5 flex flex-row items-center">
                        
                        <button className="flex gap-2 items-center border border-blue-500 rounded-md px-2 py-1 text-base hover:bg-blue-200"
                            onClick={(e) => handleSubmit(e)}
                            disabled={state.isLoading}
                        >
                            <Save size={24} className="text-primary" />
                            Sauvegarder
                        </button>
                        
                        {
                            state?.error_message && <span className="text-red-700 flex-none content-center mr-4">{state.error_message}</span>
                        }

                    </div>
                </div>
            </form>

        </>
    )
}